import Constants from "../configurations/constants";
import messages from "../configurations/messages";
import moment from "moment-timezone";

class Util {
  static maskPan(pan) {
    if (pan.length < 10) return pan;
    return `${pan.substring(0, 6)}${pan
      .substring(6, pan.length - 4)
      .replace(/./g, "*")}${pan.substring(pan.length - 4)}`;
  }
  static clone(obj) {
    return Object.assign({}, obj);
  }

  static regularFormString(val) {
    return val
      ? val.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
          return str.toUpperCase();
        })
      : null;
  }
  static defaultMapStateToProps(state, props) {
    return {
      userPermissions: state.permissions,
    };
  }

  static errorMessageToast(Toaster, error, defaultExpr) {
    //Check if the error object has multiple errors in them if so run via them and trigger a toaster call
    if (
      error &&
      typeof error === "object" &&
      Constants.ERROR_LIST_RESPONSE_PROPS in error &&
      error[Constants.ERROR_LIST_RESPONSE_PROPS].length > 0
    ) {
      let messageBuilder = "";
      error[Constants.ERROR_LIST_RESPONSE_PROPS].forEach((item) => {
        let camelCaseText =
          item.fieldName === "object"
            ? ""
            : `${Util.regularFormString(item.fieldName)} -`;
        messageBuilder += `${camelCaseText} ${item.message} <br/>`;
      });
      Toaster.error(messageBuilder, messages.ERROR_VALIDATION);
      return;
    }
    if (error && error.description) {
      Toaster.error(error.description);
      return;
    }

    //If not just show the messages as usual
    Toaster.error(...defaultExpr);
  }

  static toUserLocalTime(utcDate) {
    if (utcDate) {
      return moment(utcDate).local().format("YYYY-MM-DD HH:mm:ss");
    }
    return null;
  }

  static commanumbers(number) {
    let numberString;
    if (number !== undefined) {
      numberString = number.toLocaleString(undefined, {
        maximumFractionDigits: 2,
      });
    }
    return numberString;
  }

  static camelToSentence(camelCaseText) {
    camelCaseText = camelCaseText && camelCaseText.replace(/([A-Z])/g, " $1");
    camelCaseText =
      camelCaseText.charAt(0).toUpperCase() + camelCaseText.slice(1);
    return camelCaseText;
  }

  static isValidDate(date) {
    return date instanceof Date && !isNaN(date);
  }
}

export default Util;



// WEBPACK FOOTER //
// ./src/util/util.js